var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"english-translation mb-3"},[_c('div',{staticClass:"raised-frame px-2 pb-3 pt-1 mb-3 mx-1 text-left",attrs:{"dir":"ltr"}},[_vm._v(" "+_vm._s(_vm.englishText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }